import React from 'react';
import { Button } from './Button';
export const FeatureSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS';
  return <section className="bg-gradient-to-b from-teal-800 to-teal-700 text-white py-16" data-id="element-102">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-103">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-104">
          What Makes Neurotoned Different?
        </h2>
        <div className="mb-8 max-w-2xl mx-auto" data-id="element-105">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rSMrSVPRFdj5k4GtioQZz3/4ca5dd5-d0c-e0c-caff-b437eefd381_Untitled_design.jpg" alt="Nervous system illustration" className="w-full rounded-lg shadow-xl" data-id="element-106" />
        </div>
        <h3 className="text-2xl font-semibold mb-8 text-center" data-id="element-107">
          This isn't mindset work. This isn't therapy. This isn't an app.
        </h3>
        <div className="mb-10 space-y-6" data-id="element-108">
          <p className="text-lg" data-id="element-109">
            This is <em data-id="element-110">not</em> Calm, Headspace, Apollo Neuro, or another
            tech-based hack.
          </p>
          <p className="text-lg mb-4" data-id="element-111">
            This is a <strong data-id="element-112">therapist-designed nervous system reset</strong>{' '}
            rooted in:
          </p>
          <ul className="list-disc pl-6 space-y-3 mb-8" data-id="element-113">
            <li data-id="element-114">Trauma-informed yoga</li>
            <li data-id="element-115">Somatic experiencing techniques</li>
            <li data-id="element-116">Polyvagal theory (applied, not theoretical)</li>
            <li data-id="element-117">Expressive arts + guided movement</li>
            <li data-id="element-118">Grounded science</li>
          </ul>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg italic" data-id="element-119">
            <p data-id="element-120">
              Designed by a Doctor of Behavioral Health with 20+ years of
              experience in trauma therapy and nervous system repair.
            </p>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-121">
          <Button link={checkoutUrl} data-id="element-122">Access Now for $29 ➔</Button>
        </div>
      </div>
    </section>;
};